import axios from 'axios'
import storage from "./storage";
import router from '../router/index'
import {hideLoading, showLoading} from "./loading";
import { MessageBox, Message } from 'element-ui'

//axios 超时重试
//https://juejin.cn/post/6844903585751236621

//nginx
let baseUrl="/api"
//jar调用
//let baseUrl = 'http://127.0.0.1:8081'
//容器
//let baseUrl='http://ss.zdinfo.top:90/'
///tomat
//let baseUrl = 'http://127.0.0.1:8080/trade'
let http = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  transformRequest: [function (data) {
    let newData = '';
    if(data  instanceof  FormData){
       return data;
    }else {
      for (let k in data) {
        if (data.hasOwnProperty(k) === true) {
          newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
        }
      }
      return newData;
    }

    // let newData = '';
    // for (let k in data) {
    //   if (data.hasOwnProperty(k) === true) {
    //     newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
    //   }
    // }
    // return newData;

  }]
});
// 添加一个请求拦截器
http.interceptors.request.use(function (config) {
  // Do something before request is sent

  let passLoading = ["getVisibilityData", "getVehicleData"];
  let token = storage.get("token");
  let pass = storage.get("pass");
  let url = config.url;

  //config.headers['Authorization'] = token;

  if ((!url.includes("top")) && (!url.includes("admlogin")) ){
    config.headers['Authorization'] = token;
  }

  if((url.includes("getacc")) ||(url.includes("sms/get")) )
    config.headers['Authorization'] = pass;

  showLoading()
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// 添加一个响应拦截器
http.interceptors.response.use(function (response) {
  // Do something with response data
  hideLoading();
  return response;
}, function (error) {
  // Do something with response error
  console.log(error);
  switch (error.response.status) {
    case 401:
      Message({ type: 'error', message: '您没有登录或登录已过期。' });
      break;
    case 404:
    case 400:
      Message({ type: 'error', message: '客户端请求有语法错误，不能被服务器所理解' });
      break;
    case 403:
      Message.error({message:'权限不足,请联系管理员!'});
    case 504:
    case 505:
    case 500:
      Message({ type: 'error', message: '服务器发生不可预期的错误'});
      break;
    default:
      Message.error({ message: '未知错误:'+error.response.status});
  }
  hideLoading();

  return Promise.reject(error);
});

function apiAxios(method, url, params, response) {
  http({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
  }).then(function (res) {
    response(res);
  }).catch(function (err) {
    response(err);
  })
}

function upload(method, url, params, response) {
  http({
    method: method,
    url: url,
    //data: method === 'POST' || method === 'PUT' ? params : null,
    //params: method === 'GET' || method === 'DELETE' ? params : null,
    data: params,
    //headers: { 'Content-Type': 'multipart/form-data;charset=utf-8' },
  }).then(function (res) {
    response(res);
  }).catch(function (err) {
    response(err);
  })
}

function makeExcel(method, url, params, response) {
  http({
    responseType: 'blob',
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
  }).then(function (res) {
    response(res);
    /*const link = document.createElement('a')
    let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)

    link.download = res.headers['content-disposition'].replace("attachment; filename=",""); //下载后文件名
    //link.download = 'charset.xls' //下载的文件名
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)*/

    //https://blog.csdn.net/w284511883/article/details/108380652

    let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) // 将服务端返回的文件流（二进制）excel文件转化为blob
    let contentDisposition = res.headers['content-disposition'];
    // fileName必用这种方式进行解析，否则乱码
    let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=')+1));
    console.log('fileName=' + fileName);
    let url = (window.URL || window.webkitURL).createObjectURL(blob)
    let a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.setAttribute('download',fileName);
    document.body.appendChild(a);
    //点击下载
    a.click();
    // 下载完成移除元素
    document.body.removeChild(a);
    // 释放掉blob对象
    window.URL.revokeObjectURL(url);

  }).catch(function (err) {
    response(err);
  })
}

function apiAxiosHead(url, params, head, response) {
  axios.post(baseUrl + url, params, response,
    {
      headers: head,
    }
  ).then(function (res) {
    response(res);
  }).catch(function (err) {
    response(err);

  })
}



export default {
  get: function (url, params, response) {
    return apiAxios('GET', url, params, response)
  },
  post: function (url, params, response) {
    return apiAxios('POST', url, params, response)
  },
  put: function (url, params, response) {
    return apiAxios('PUT', url, params, response)
  },
  delete: function (url, params, response) {
    return apiAxios('DELETE', url, params, response)
  },
  postHead: function (url, params, head, response) {
    return apiAxiosHead(url, params, head, response)
  },
  makeExcel: function (url, params, response) {
    return makeExcel('POST', url, params, response);
  },
  upload: function(url, params, response){
    return upload('POST', url, params, response);
  },
  baseUrl: function () {
    return baseUrl
  }


}




// WEBPACK FOOTER //
// ./src/api/axios.js